import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import styles from "./styles.module.css";
import { useHistory } from "react-router-dom";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import api from '../../services/api_escala';


export default function Escala() {


    const [cenarios, setCenarios] = useState([]);
    const [cenariosEdicao, setCenariosEdicao] = useState([]);
    

    useEffect(() => {
        api.get(`/cenario`).then(function (response) {
            if (response.data) {
                setCenarios(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);

    useEffect(() => {
        api.get(`/cenarioedicao`).then(function (response) {
            if (response.data) {
                setCenariosEdicao(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    

    function tileClassName({ date, view }) {
        var classname = {};

        

        cenarios.map((cenario) => {
            if (moment(date).utc().format('DD/MM/YYYY') === moment(cenario.data).utc().format('DD/MM/YYYY')) {
                classname = styles.hasescala
            }
            if (moment(date).utc().format('DD/MM/YYYY') === moment(new Date()).utc().format('DD/MM/YYYY')) {
                classname = styles.today
            }
        });
        cenariosEdicao.map((cenario) => {
            if (moment(date).utc().format('DD/MM/YYYY') === moment(cenario.data).utc().format('DD/MM/YYYY')) {
                classname = styles.hasnotsalve
            }
            if (moment(date).utc().format('DD/MM/YYYY') === moment(new Date()).utc().format('DD/MM/YYYY')) {
                classname = styles.today
            }
        });

        return classname;


    }

    let history = useHistory();

    const [value, onChange] = useState(new Date());

    function clickDay(day) {
        history.push(`/porfrota?data=${moment(day).utc().format('YYYY-MM-DD')}`)
    }

    return (
        <>
            <div className="container-lg">
                <Header title="PLANEJAMENTO DE ESCALA" />
                <div className={styles.bodycalendar}>
                    <Calendar
                        onChange={onChange}
                        value={value}
                        tileClassName={tileClassName}
                        onClickDay={clickDay}
                    />
                </div>
            </div>
            <div className={styles.legenda}>
                <div className={styles.hasescalaitem} >CENÁRIOS SALVOS</div>
                <div className={styles.hasnotsalveitem}>CENÁRIOS NÃO SALVOS</div>
            </div>
        </>
    )
}